var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "swiperBox" },
    [
      _c(
        "el-carousel",
        { attrs: { interval: 3000, arrow: "always", autoplay: true } },
        _vm._l(_vm.swiperList, function (item, index) {
          return _c("el-carousel-item", { key: index }, [
            _c(
              "div",
              {
                staticClass: "img_w",
                on: {
                  click: function ($event) {
                    return _vm.toLink(item.linkUrl)
                  },
                },
              },
              [
                _c("img", {
                  staticClass: "img",
                  attrs: { src: item.imageUrl, alt: "" },
                }),
              ]
            ),
          ])
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }